import { Login } from '@/features/Auth/Login';

export default function Page() {
  return <Login />;
}

Page.hideFullLayout = true;
